import httpUtil from "@/utils/httpUtil";

export const selectAgentCompanyList = params => httpUtil.post("/api/crmPc/companyGoods/selectAgentCompanyList", params);


export const getAdminCompanyInfo = params => httpUtil.post("/api/crmPc/companyGoods/getAdminCompanyInfo", params);

